import React, { useRef, useState, useEffect } from 'react';
import ReactPlayer from 'react-player';

import classes from './InPlacePlayer.module.css';
import { IsStringEmpty } from '../../utilities/CommonMethods';


const InPlacePlayer = (props) => {

    // let instanceStyles = "color: blue; font-weight: bold; font-size: 1.1em;";
    // let instanceStyles2 = "color: orange; font-weight: bold; font-size: 1.1em;";


    const playerIframe = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [player, setPlayer] = useState(null);
    const [vimeoId, setvimeoId] = useState('')
    const [percentage, setPercentage] = useState(0)
    const [tpStream, setTPStream] = useState(true)

    const getTotalWatchTime = () => {
        // console.log("%c---------------------------------------------------", "border-bottom: 2px solid red;")
        // console.log(`%cgetTotalWatchTime function = ${isPlaying}`, "color: teal; font-size: 1.1em; font-weight: bold;")

        if (player) {
            // console.log(`%cgetTotalWatchTime isPlaying = ${isPlaying}`, "color: purple; font-size: 1.1em; font-weight: bold;")
            let totalDuration = 0;
            player.getDuration().then(function (duration) {
                totalDuration = duration;
            });
            player.played().then(function (ranges) {
                let finalWatchTime = 0;

                finalWatchTime = ranges[ranges.length - 1][1];
                let percent = Math.round(finalWatchTime / totalDuration * 100);
                setPercentage(percent > 100 ? 100 : percent);

                if (percent >= 90 && props.markAttendance) {
                    props.markStudentAttendance(90);
                } else if (percent >= 50 && props.markAttendance && props.fiftyPercentMarked === false) {
                    props.markStudentAttendance(50);
                }

                // console.log('Percentage:', percent > 100 ? 100 : percent, '%', props.markAttendance);
            }).catch(function (error) {
                console.error('Error getting played ranges:', error);
            });
        }
    };

    const loadPlayer = () => {
        // console.log("Player Instance: inside loadPlayer func - Vimeo ID = ", props.vimeoId)
        const iframe = playerIframe.current;
        if (iframe) {
            const playerInstance = new window.Testpress.Player(iframe);
            // console.log('playerInstance >>> ', playerInstance);
            setPlayer(playerInstance);
            setvimeoId(props.vimeoId);

            playerInstance.loaded().then(() => {
                // console.log('%cPlayer Instance: loaded', instanceStyles)
            });

            playerInstance.on('play', () => {
                // console.log('%cPlayer Instance: play', instanceStyles)
                setIsPlaying(true);
                // alert(true + ' : ' + isPlaying)
            });

            playerInstance.on('pause', () => {
                // console.log('%cPlayer Instance: pause', instanceStyles)
                setIsPlaying(false);
            });

            playerInstance.on('timeupdate', () => {
                // console.log('%ctimeupdate => ' + new Date().toLocaleTimeString(), instanceStyles)
                getTotalWatchTime();
            })

            playerInstance.on('ended', () => {
                setIsPlaying(false);
                getTotalWatchTime(); // Ensure we capture the final ranges
            });

        }

    };

    useEffect(() => {
        if (props.vimeoId) {
            setTPStream(props.vimeoId.length > 9 ? true : false);
        }

        if (window.Testpress) {
            loadPlayer();
        } else {
            const script = document.createElement('script');
            script.src = 'https://static.testpress.in/static/js/player.js';
            script.onload = loadPlayer;
            document.body.appendChild(script);
        }

    }, [player, props.vimeoId])

    const onIframeLoaded = () => {
        // console.log('%cLoaded the script!!!', 'color: green; font-weight: bold;font-size: 20px; border: 2px solid red;');

        if (player !== null) {
            player.off('play')
            player.off('pause')
            player.off('ended')
            player.off('timeupdate')
            setPlayer(null);
            setIsPlaying(false);

            loadPlayer();
        }
    }

    // ---------- Below Function handles the progress for VIMEO VIDEO PLAYER ------------
    const onProgress = (progress) => {
        // console.log('Progress => ', (progress.played).toFixed(2), props.markAttendance, props.fiftyPercentMarked)
        if ((progress.played).toFixed(2) >= 0.90 && props.markAttendance) {
            props.markStudentAttendance(90);
        } else if ((progress.played).toFixed(2) >= 0.50 && props.markAttendance && props.fiftyPercentMarked === false) {
            props.markStudentAttendance(50);
        }
    }

    return (
        <div className={[classes.PlayerWrapper, props.inline ? classes.Inline : null].join(' ')} onClick={props.clicked}>
            {
                tpStream === true
                    ? <iframe width='100%' height='100%' ref={playerIframe} className={classes.ReactPlayer}
                        src={`https://app.tpstreams.com/embed/fyd3gg/${props.vimeoId}`}
                        // title='DDE video 12'
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                        allowFullScreen onLoad={onIframeLoaded}>
                    </iframe>

                    : (!props.play && !IsStringEmpty(props.thumbnail) && props.inline) || (IsStringEmpty(props.vimeoId)) ? null :
                        <ReactPlayer
                            className={classes.ReactPlayer}
                            width='100%'
                            height='100%'
                            ref={null}
                            url={'https://player.vimeo.com/video/' + props.vimeoId}
                            playing={props.play}
                            loop={false}
                            onPlay={() => props.onPlay()}
                            onPause={() => props.onPause()}
                            onEnded={() => { props.onVideoEnded() }}
                            onProgress={onProgress}
                            controls={true}
                            onReady={props.showVideoLoading ? props.onVideoLoaded : null}
                        />
            }
        </div>
    );
}

export default InPlacePlayer;